import { Box, Typography } from '@mui/material';
import { sxConfig } from './calendarStyle';
import useParam from '../../context/ParamContext';
import { useEffect, useState } from 'react';
import { formatValue } from '../../utils/resource.planner';

const TooltipContent = ({ eventInfo }) => {
  const { params } = useParam();
  const [tooltipObj, setTooltipObj] = useState(null);

  useEffect(() => {
    let paramKey = 'TASKCALENDAR_HINT_CONTENT';

    if (params[paramKey]) {
      const parsedObj = JSON.parse(params[paramKey]);
      setTooltipObj(parsedObj);
    }
  }, [params]);

  const eventData = eventInfo?.event?.extendedProps;

  const getFieldValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      if (Array.isArray(acc)) {
        return acc.map((item) => item[part]);
      }
      return acc ? acc[part] : null;
    }, obj);
  };

  const setTooltipContent = () => {
    if (!tooltipObj || !eventData) {
      return null;
    }

    return tooltipObj.map((item, index) => {
      const { label, fieldName, type } = item;
      const taskValue = getFieldValue(eventData, fieldName);

      return (
        <Typography key={index}>
          {label}: {formatValue(taskValue, type)}
        </Typography>
      );
    });
  };

  const tooltipContent = setTooltipContent();

  return (
    <Box>
      {tooltipContent || (
        <Box sx={sxConfig.tooltipContent}>
          <Typography sx={sxConfig.tooltipContentFirstTyp}>Megjegyzés:</Typography>
          <Typography>{eventData.description}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default TooltipContent;
